import React, { useState } from "react";
import FaxIcon from "@mui/icons-material/Fax";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PlaceIcon from "@mui/icons-material/Place";
import { Link } from "react-router-dom";
export default function ContactForm() {
  // const initialFormData = {
  //   username: "",
  //   email: "",
  //   message: "",
  //   number: "",
  // };
  // const [formData, setFormData] = useState(initialFormData);
  // const [errors, setErrors] = useState({});
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  // };
  // const ValidateFrom = () => {
  //   const newErrors = {};
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   if (!formData.username) {
  //     newErrors.username = "Username is required";
  //   }
  //   if (!formData.email || !emailRegex.test(formData.email)) {
  //     newErrors.email = "Valid Email is required";
  //   }
  //   if (!formData.message) {
  //     newErrors.message = "Message is required";
  //   }
  //   if (!formData.number) {
  //     newErrors.number = "Number is required";
  //   }
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };
  // const handleSubmit = (e) => {
  //   ValidateFrom();
  //   e.preventDefault();
  //   console.log(formData);
  // };
  return (
    <div className="flex justify-center items-center w-full lg:mt-14 2xl:mt-20">
      <div className="w-11/12 xl:w-4/5 3xl:w-3/5 md:my-16 my-8 grid grid-cols-1 lg:grid-cols-2 gap-10 font-robout">
        {/* LEFT SIDE */}

        <ul className="flex flex-col gap-5 justify-center text-white text-xl md:text-left leading-[1.4] text-[1.4rem] text-center">
          <li className="flex flex-row gap-5 items-center  mjustify-start  leading-[1.4] text-[1.4rem] ">
            <LocalPhoneIcon
              fontSize="30px"
              className="text-3xl text-[#d78558]"
            />
            <a aria-label="faz" href="tel:352-795-9200">
              352-795-9200
            </a>
          </li>

          <li className="flex flex-row gap-5 items-center justify-start leading-[1.4] text-[1.4rem] ">
            <FaxIcon fontSize="30px" className="text-3xl text-[#d78558]" />
            <a aria-label="phone" href="tel:352-795-6460">
              352-795-6460
            </a>
          </li>

          <li className="flex flex-row gap-5 items-center justify-start leading-[1.4] text-[1.4rem]">
            <PlaceIcon fontSize="30px" className="text-3xl text-[#d78558]" />
            <Link
              to="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
              target="_blank"
              aria-label="Address"
            >
              922 North Citrus Avenue <br /> Crystal River, Florida 34428
            </Link>
          </li>
          <li className="flex flex-row gap-5 items-center text-2xl  justify-start leading-[1.4] text-[1.4rem]">
            <CalendarMonthIcon
              fontSize="30px"
              className="text-3xl text-[#d78558]"
            />
            <span>
              Mon-Fri: 8:30am – 5pm
              <br /> (Excluding Holidays)
            </span>
          </li>
        </ul>

        {/* RIGHT SIDE */}
        <div className="flex justify-center items-start text-white text-lg md:text-xl xl:text-2xl">
          <div data-aos="fade-up" className="text-left">
            <h3
              data-aos="fade-up"
              className="text-[#d78558] xl:text-4xl md:text-3xl text-2xl tracking-wide mb-4"
            >
              Appointment Confirmation & Cancellation Policy
            </h3>

            <ul className="text-left  leading-[1.4] text-[1.4rem]">
              <li>
                <span>
                  To help us serve all our patients efficiently, a member of our
                  staff will contact you by phone and/or text a few days prior
                  to your appointment to confirm. If you need to cancel or
                  reschedule, we kindly ask that you notify us at least 24 hours
                  in advance.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

/* <form
          className="flex flex-col justify-center  md:gap-16 items-center"
          onSubmit={(e) => handleSubmit(e)}
        >
          <div className="grid md:grid-cols-2 grid-cols-1 xl:w-4/5 md:gap-8 md:w-11/12 w-full">
            <div className="">
              <div
                data-aos="fade-up"
                data-aso-delay="100"
                className="relative z-0 w-full group xl:my-[5.135rem] md:my-16 my-8 flex flex-col-reverse"
              >
                <input
                  type="text"
                  name="username"
                  id="name"
                  onChange={(e) => handleChange(e)}
                  className="pt-[1.2rem] bg-red pb-[1.6rem] tracking-[0.02em] text-[1.3rem] font-robout text-white outline-2 outline-transparent outline-offset-2  appearance-none outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#d78558] md:w-[90%] w-full focus:outline-none focus:ring-0 focus:border-[#d78558] peer"
                />
                <label
                  htmlFor="name"
                  className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-robout text-[1rem] text-white tracking-[.2em] form-line-flex focus-within:[&>label]:text-[#d78558] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#d78558] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Your name
                </label>
                {errors.username && (
                  <div className="text-red-500 absolute bottom-[2px] text-xl">
                    {errors.username}
                  </div>
                )}
              </div>
              <div
                data-aos="fade-up"
                data-aso-delay="300"
                className="relative z-0 w-full group xl:my-[5.135rem] md:my-16 my-8 flex flex-col-reverse"
              >
                <input
                  type="text"
                  name="number"
                  onChange={(e) => handleChange(e)}
                  id="number"
                  className="pt-[1.2rem] pb-[1.6rem] tracking-[0.02em] text-[1.3rem] font-robout text-white outline-2 outline-transparent outline-offset-2  appearance-none outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#d78558] md:w-[90%] w-full focus:outline-none focus:ring-0 focus:border-[#d78558] peer"
                />
                <label
                  htmlFor="number"
                  className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-robout text-[1rem] text-white tracking-[.2em] form-line-flex focus-within:[&>label]:text-[#d78558] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#d78558] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Your phone number
                </label>
                {errors.number && (
                  <div className="text-red-500 absolute bottom-[2px] text-xl">
                    {errors.number}
                  </div>
                )}
              </div>
              <div
                data-aos="fade-up"
                data-aso-delay="300"
                className="relative z-0 w-full group xl:my-[5.135rem] md:my-16 my-8 flex flex-col-reverse"
              >
                <input
                  type="email"
                  name="email"
                  id="email"
                  onChange={(e) => handleChange(e)}
                  className="pt-[1.2rem] pb-[1.6rem] tracking-[0.02em] text-[1.3rem] font-robout text-white outline-2 outline-transparent outline-offset-2  appearance-none outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#d78558] md:w-[90%] w-fullfocus:outline-none focus:ring-0 focus:border-[#d78558] peer"
                  placeholder=""
                />
                <label
                  htmlFor="email"
                  className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-robout text-[1rem] text-white tracking-[.2em] form-line-flex focus-within:[&>label]:text-[#d78558] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#d78558] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Your email
                </label>
                {errors.email && (
                  <div className="text-red-500 absolute bottom-[2px] text-xl">
                    {errors.email}
                  </div>
                )}
              </div>
            </div>
            <div data-aos="fade-up" data-aso-delay="300" className="">
              <div className="mt-[2.6rem] mb-[1rem] relative my-[3.135rem] ">
                <textarea
                  placeholder="Your message"
                  id="form-input-message"
                  cols="30"
                  rows="14"
                  name="message"
                  onChange={(e) => handleChange(e)}
                  className="bg-transparent mt-[.25rem] w-full rounded-[2rem] py-[1.5rem] px-[2rem] outline-none border-[max(1px,_0.0625rem)] border-solid border-[#d78558] h-[15rem] md:h-[22.5rem] xl:h-[28.1rem] text-[1.3rem] text-white font-robout font-semibold placeholder-white placeholder:uppercase placeholder:tracking-[.2em] placeholder:text-[1rem]"
                ></textarea>
                {errors.message && (
                  <div className="text-red-500 absolute bottom-4 left-4 text-xl">
                    {errors.message}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className=" text-center">
            <div data-aos="fade-up" className="">
              <div className="inline-flex  bg-transparent relative h-[3.5rem] items-center rounded-[9999px] px-[2rem] text-[1.125rem] font-semibold font-robout tracking-[-.06em] ">
                <button
                 aria-label="Submit"
                  type="submit"
                  className="group relative inline-flex h-14 mt-6  items-center rounded-full px-16  font-semibold text-black bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>
                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center font-robout tracking-wider items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      submit
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 font-robout tracking-wider left-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      submit
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </form> */
